<template>
    <v-container v-if="isCreating">
        <v-card>
            <h2 class="text-center">Create New Species Batch Pool</h2>
            <v-progress-linear slot="progress" color="primary" indeterminate v-if="createdLoading"></v-progress-linear>
            <v-row v-else>
                <v-col cols="12" md="6" offset-md="3">
                    <v-form @submit.prevent ref="editForm" v-model="createValid">
                        <v-row >
                            <v-col cols="12">
                                <v-select
                                    :items="species"
                                    item-text="SpeciesFullName"
                                    item-value="SpeciesID"
                                    v-model="newRecord.SpeciesID"
                                    label="Species"
                                    :rules="[rules.selectIDRequired]"
                                ></v-select>
                            </v-col>

                            <v-col cols="12">
                                <v-select
                                    :items="types"
                                    item-text="TypeName"
                                    item-value="TypeValue"
                                    v-model="newRecord.IsExternal"
                                    label="Type"
                                    :rules="[rules.selectIDRequired]"
                                ></v-select>
                            </v-col>
                            
                            <v-col cols="12" class="text-center">
                                <v-btn
                                    :disabled="!createValid"
                                    :loading="loadingData"
                                    color="accent"
                                    @click="createRecord()"
                                >
                                    Create
                                </v-btn>
                            </v-col>

                            <v-col cols="12" class="text-center">
                                <v-alert v-if="error" outlined :value="true" color="error" icon="error">
                                    {{error}}
                                </v-alert>
                            </v-col>

                        </v-row>
                    </v-form>
                </v-col>
            </v-row>
        </v-card>
    </v-container>
    <v-container v-else>
        <v-card>
            <h2 class="text-center">{{speciesBatchPool.IsClosed ?  (speciesBatchPool.IsExternal ? "External" : "Internal") + " Species Batch Pool Details" : "Manage " + (speciesBatchPool.IsExternal ? "External" : "Internal") + " Species Batch Pool"}}</h2>
            <v-row >

                <v-col cols="12" md="6" offset-md="3" class="text-center">
                    <v-alert v-if="error" outlined :value="true" color="error" icon="error">
                        {{error}}
                    </v-alert>
                </v-col>

                <v-progress-linear slot="progress" color="primary" indeterminate v-if="loadingData"></v-progress-linear>

                <v-col cols="12" md="9" offset-md="3" v-else>
                    <v-row no-gutters>

                        <v-col cols="12" md="4">
                            <v-row no-gutters>
                                <v-col cols="3">
                                    Barcode
                                </v-col>
                                <v-col cols="9" class="highlighted-data">
                                    {{ (speciesBatchPool && speciesBatchPool.Barcode) ? speciesBatchPool.Barcode.toUpperCase() : "" }}
                                </v-col>
                            </v-row>
                        </v-col>

                    </v-row>

                    <v-row no-gutters>

                        <v-col cols="12" md="4">
                            <v-row no-gutters>
                                <v-col cols="3">
                                    Created
                                </v-col>
                                <v-col cols="9" class="highlighted-data">
                                    {{ $moment(speciesBatchPool.CreatedTime).format($constants.DATE_FORMAT) }}
                                </v-col>
                            </v-row>
                        </v-col>

                        <v-col cols="12" md="8">
                            <v-row no-gutters>
                                <v-col cols="2">
                                    By
                                </v-col>
                                <v-col cols="10" class="highlighted-data">
                                    {{ speciesBatchPool.CreatedByFullName}} ({{speciesBatchPool.CreatedByEmail}})
                                </v-col>
                            </v-row>
                        </v-col>

                    </v-row>

                    <v-row no-gutters>

                        <v-col cols="12" md="4" v-if="speciesBatchPool.IsClosed">
                            <v-row no-gutters>
                                <v-col cols="3">
                                    Closed
                                </v-col>
                                <v-col cols="9" class="highlighted-data">
                                    {{ $moment(speciesBatchPool.ClosedTime).format($constants.DATE_FORMAT) }}
                                </v-col>
                            </v-row>
                        </v-col>

                        <v-col sm="12" md="8" v-if="speciesBatchPool.IsClosed">
                            <v-row no-gutters>
                                <v-col cols="2">
                                    By
                                </v-col>
                                <v-col cols="10" class="highlighted-data">
                                    {{ speciesBatchPool.ClosedByFullName}} ({{speciesBatchPool.ClosedByEmail}})
                                </v-col>
                            </v-row>
                        </v-col>

                    </v-row>

                    <v-row no-gutters>

                        <v-col cols="12" md="4">
                            <v-row no-gutters>
                                <v-col cols="3">
                                    Species
                                </v-col>
                                <v-col cols="9" class="highlighted-data">
                                    {{ speciesBatchPool.SpeciesFullName }}
                                </v-col>
                            </v-row>
                        </v-col>

                        <v-col cols="12" md="6">
                            <v-row no-gutters>
                                <v-col cols="4">
                                    Total Weight
                                </v-col>
                                <v-col cols="8" class="highlighted-data">
                                    {{ speciesBatchPoolTotalWeight || 0 }}g
                                </v-col>
                            </v-row>
                        </v-col>

                    </v-row>

                    <v-row no-gutters>
                        <v-col cols="12" md="4">
                            <v-row no-gutters>
                                <v-col cols="4">
                                    Total Weight in VenomLot
                                </v-col>
                                <v-col cols="8" class="highlighted-data">
                                    {{ speciesBatchPool.TotalAddedWeight || 0 }}g
                                </v-col>
                            </v-row>
                        </v-col>

                        <v-col cols="12" md="6">
                            <v-row no-gutters>
                                <v-col cols="4">
                                    Remaining Weight
                                </v-col>
                                <v-col cols="8" class="highlighted-data">
                                    {{ speciesBatchPoolRemainingWeight || 0 }}g
                                </v-col>
                            </v-row>
                        </v-col>

                    </v-row>

                    <v-row>
                        <v-col cols="12" md="8" class="text-center">
                            <v-btn
                                color="success"
                                @click="closePool()"
                                v-if="!speciesBatchPool.IsClosed&& speciesBatchPoolRemainingWeight <= 0 &&speciesBatchPool.TotalAddedWeight>0"
                            >
                                Close Pool
                            </v-btn>
                            <v-btn
                                color="info"
                                @click="printBarcode()"
                                class="ml-2"
                            >
                                Print Barcode
                            </v-btn>
                            <v-btn
                                color="info"
                                @click="exportSpeciesBatchPool"
                                :disabled="exporting" 
                                :loading="exporting"
                                class="ml-2"
                            >
                                Export
                            </v-btn>
                            <v-btn
                                color="info"
                                @click="print"
                                class="ml-2"
                            >
                                Print
                            </v-btn>
                        </v-col>

                    </v-row>
                </v-col>
            </v-row>
        </v-card>
        
        <v-card v-if="!loadingData && !speciesBatchPool.IsClosed" class="pa-0">
            <v-expansion-panels>
                <v-expansion-panel>
                    <v-expansion-panel-header>
                        <div class="title text-center">Add Monthly Pools</div>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content >
                        <v-row>
                            <v-col cols="12" md="6" offset-md="3">
                                <SpeciesBatchPoolAvailableMonthlyPools
                                    :speciesID="speciesBatchPool.SpeciesID"
                                    :isExternal="speciesBatchPool.IsExternal"
                                    :speciesBatchPoolID="speciesBatchPool.SpeciesBatchPoolID"
                                    @recordsAdded="monthlyPoolRecordsAdded"
                                >
                                </SpeciesBatchPoolAvailableMonthlyPools>
                            </v-col>
                        </v-row>
                    </v-expansion-panel-content>
                </v-expansion-panel>
            </v-expansion-panels>
        </v-card>

        <v-card v-if="!loadingData" class="pa-0">
            <v-expansion-panels>
                <v-expansion-panel>
                    <v-expansion-panel-header>
                        <div class="title text-center">Entered Records</div>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                        <v-row>
                            <v-col cols="12" md="6" offset-md="3">
                                <v-data-table
                                    :headers="enteredRecordsHeaders"
                                    :items="speciesBatchPool.MonthlyPools"
                                    :loading="loadingData || loadingEnteredRecords"
                                    :items-per-page.sync="enteredRecordsPagination.rowsPerPage"
                                    must-sort>
                                    <v-progress-linear slot="progress" color="primary" indeterminate></v-progress-linear>
                                    <template  v-slot:item="props">
                                        <tr :data-id="props.item.MonthlyPoolID">
                                            <td>{{props.item.Barcode}}</td>
                                            <td>{{props.item.SpeciesFullName}}</td>
                                            <td>{{props.item.TotalWeight || 0}}g</td>
                                            <td>
                                                <v-btn
                                                    color="info"
                                                    block
                                                    @click="viewMonthlyPool(props.item.MonthlyPoolID)"
                                                >
                                                    View Monthly Pool
                                                </v-btn>
                                            </td>
                                        </tr>
                                    </template>
                                    <template v-if="!loadingEnteredRecords" slot="no-data">
                                        <v-alert outlined :value="true" type="info">
                                            No Monthly Pools added
                                        </v-alert>
                                    </template>
                                </v-data-table>
                            </v-col>
                        </v-row>
                        
                        <DashboardPieGraph 
                            :height="graphHeight" 
                            :data="pieGraphData" 
                            :options="pieGraphOptions"
                        >
                        </DashboardPieGraph>
                    </v-expansion-panel-content>
                </v-expansion-panel>
            </v-expansion-panels>
        </v-card>

        <v-card v-if="!loadingData" class="pa-0">
            <v-expansion-panels>
                <v-expansion-panel>
                    <v-expansion-panel-header>
                        <div class="title text-center">Venom Analysis</div>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                        <VenomAnalysis
                            :speciesBatchPoolID="speciesBatchPoolIDInteger">
                        </VenomAnalysis>
                    </v-expansion-panel-content>
                </v-expansion-panel>
            </v-expansion-panels>
        </v-card>

        <SpeciesBatchPoolCloseDialog ref="closeDialog" @updated="loadData"></SpeciesBatchPoolCloseDialog>

    </v-container>
</template>

<script>

import VenomAnalysis from '../venomanalysis/VenomAnalysis';
import SpeciesBatchPoolAvailableMonthlyPools from './SpeciesBatchPoolAvailableMonthlyPools';
import SpeciesBatchPoolCloseDialog from "@/components/venompooling/SpeciesBatchPoolCloseDialog";
import DashboardPieGraph from "@/components/dashboard/DashboardPieGraph"
import util from '@/helpers/util';
import validationRules from "../../helpers/validationrules";
import * as VenomPoolingAPI from "@/services/venomPoolingAPI";
import constants from 'comunet-btg-utah-repository-shared/constants';
import exports from "@/services/export";

import moment from 'moment';

export default {
    components: {
        VenomAnalysis,
        SpeciesBatchPoolAvailableMonthlyPools,
        SpeciesBatchPoolCloseDialog,
        DashboardPieGraph
    },
    props: {
        
    },
    data() {
        return {
            rules: validationRules.rules,

            newRecord: {
                IsExternal: 0
            },
            createValid: false,
            createError: null,

            loadingData: false,
            speciesBatchPool: {},
            loadingEnteredRecords: false,
            loadError: null,

            types: [
                {
                    TypeName: "Internal",
                    TypeValue: 0
                },
                {
                    TypeName: "External",
                    TypeValue: 1
                }
            ],

            enteredRecordsHeaders: [
                {
                    text: "Barcode",
                    value: "Barcode"
                },
                {
                    text: "Species",
                    value: "SpeciesFullName"
                },
                {
                    text: "Weight",
                    value: "TotalWeight"
                },
                {
                    text: "",
                    value: ""
                }
            ],
            enteredRecordsPagination: {
                rowsPerPage: 10,
            },

            graphHeight: 150,
            pieGraphData: {
                labels: [],
                datasets: [
                    {
                        label: "Location",
                        data: [],
                        backgroundColor: [
                            '#FF6633', '#FFB399', '#FF33FF', '#FFFF99', '#00B3E6', 
                            '#E6B333', '#3366E6', '#999966', '#99FF99', '#B34D4D',
                            '#80B300', '#809900', '#E6B3B3', '#6680B3', '#66991A', 
                            '#FF99E6', '#CCFF1A', '#FF1A66', '#E6331A', '#33FFCC',
                            '#66994D', '#B366CC', '#4D8000', '#B33300', '#CC80CC', 
                            '#66664D', '#991AFF', '#E666FF', '#4DB3FF', '#1AB399',
                            '#E666B3', '#33991A', '#CC9999', '#B3B31A', '#00E680', 
                            '#4D8066', '#809980', '#E6FF80', '#1AFF33', '#999933',
                            '#FF3380', '#CCCC00', '#66E64D', '#4D80CC', '#9900B3', 
                            '#E64D66', '#4DB380', '#FF4D4D', '#99E6E6', '#6666FF'
                        ]
                    }
                ]
            },
            pieGraphOptions: {},

            exporting: false
        }
    },
    computed: {
        speciesBatchPoolID() {
            return this.$route.params.speciesBatchPoolID;
        },
        error() {
            return this.createError || this.loadError;
        },
        isCreating() {
            return !(this.speciesBatchPoolID && this.speciesBatchPoolID > 0);
        },
        createdLoading() {
            return this.$store.state.speciesStore.loading
        },
        species() {
            return this.$store.state.speciesStore.species.filter(s => s.Active).sort(util.sortByField("SpeciesFullName"));
        },
        suppliers() {
            return this.$store.state.supplierStore.suppliers.filter(s => s.Active && s.IsVenomSupplier).sort(util.sortByField("SupplierName"));
        },
        pendingFileValid() {
            return this.pendingFileName && this.pendingFileName != "" && this.pendingFile && this.pendingFile != null;
        },
        speciesBatchPoolIDInteger() {
            return parseInt(this.speciesBatchPoolID)
        },
        speciesBatchPoolTotalWeight() {
            let weight = 0;

            if (this.speciesBatchPool && this.speciesBatchPool.MonthlyPools) {
                for (const monthlyPool of this.speciesBatchPool.MonthlyPools) {
                    weight = weight + (monthlyPool.TotalWeight || 0);
                }
            }

            return weight;
        },
        speciesBatchPoolRemainingWeight() {
            if (this.speciesBatchPool) {
                return this.speciesBatchPool.TotalRemainingWeight;
            }

            return 0;
        },
    },
    methods: {
        async exportSpeciesBatchPool() {
            try {
                this.exporting = true;

                await exports.exportSpeciesBatchPool(this.speciesBatchPoolID);
            }
            catch (e) {
                this.loadError = e;

                // eslint-disable-next-line no-console
                console.log(e);
            }
            finally {
                this.exporting = false;
            }
        },
        print() {
            let routeData = this.$router.resolve({name: 'printspeciesbatchpool', params: { speciesBatchPoolID: this.speciesBatchPoolID }});
            window.open(routeData.href, '_blank');
        },
        monthlyPoolRecordsAdded() {
            this.loadData(true);
        },
        async createRecord() {
            this.loadingData = true;

            try {
                // we need to send the date according to the user to the server (this is used when generating the unique barcodes for species batch pools)
                this.newRecord.SpeciesBatchPoolDate = moment().format(constants.MYSQL_DATE_FORMAT);

                const savedRecordID = await VenomPoolingAPI.saveSpeciesBatchPool(this.newRecord);

                this.$router.replace({
                    name: "speciesBatchPool",
                    params: {
                        speciesBatchPoolID: savedRecordID
                    }
                });
            }
            catch (e) {
                // only turn off the loading indicator if there was an error
                // if there was no error then we will proceed to load the new record, so the loading indicator should remain on
                this.createError = e;

                // eslint-disable-next-line no-console
                console.log(e);

                this.loadingData = false;
            }
            finally {

            }
        },
        async loadData(alternateLoadingIndicator = false) {
            if (alternateLoadingIndicator) {
                this.loadingEnteredRecords = true;
            }
            else {
                this.loadingData = true;
            }
            
            try {
                this.speciesBatchPool = await VenomPoolingAPI.getSpeciesBatchPools({ speciesBatchPoolID: this.speciesBatchPoolID });

                // put data in correct place for graphs

                const newLabels = [];
                const newData = [];

                const graphData = this.speciesBatchPool.GeographicalLocations;
                for (const datum of graphData) {
                    newLabels.push(datum.GeographicalLocationName);
                    newData.push(datum.ContributionValue);
                }

                this.pieGraphData.labels = newLabels;
                this.pieGraphData.datasets[0].data = newData;
            }
            catch (e) {
                this.loadError = e;

                // eslint-disable-next-line no-console
                console.log(e);
            }
            finally {
                this.loadingData = false;
                this.loadingEnteredRecords = false;

                this.alertClosePool()
            }
        },
        alertClosePool() {
            if(this.speciesBatchPoolRemainingWeight <= 0 && !this.speciesBatchPool.IsClosed){
                this.closePool()
            }
        },
        printBarcode() {
            let routeData = this.$router.resolve({name: 'printbarcode', params: { barcode: this.speciesBatchPool.Barcode }});
            window.open(routeData.href, '_blank');
        },
        viewMonthlyPool(monthlyPoolID) {
            let routeData = this.$router.resolve({name: 'monthlypoolmanagementbyid', params: { monthlyPoolID: monthlyPoolID }});
            window.open(routeData.href, '_blank');
        },
        async saveAnalysis() {
            this.savingVenomAnalysis = true;

            await VenomPoolingAPI.createUpdateMonthlyPool({
                MonthlyPoolID: this.speciesBatchPool.MonthlyPoolID,
                AnalysisComments: this.speciesBatchPool.AnalysisComments
            });

            this.savingVenomAnalysis = false; 
        },
        closePool() {
            this.$refs.closeDialog.showDialog(this.speciesBatchPool.SpeciesBatchPoolID, this.speciesBatchPoolRemainingWeight <= 0);
        }
    },
    watch: {
        $route(to, from) {
            // the route changes as a result of what we do in createRecord() - we navigate to the same route
            // see note under https://router.vuejs.org/guide/essentials/navigation.html#router-push-location-oncomplete-onabort about when the destination is the same as the current route

            this.loadData();
        }
    },
    created() {
        this.$store.dispatch("speciesStore/loadSpecies");
        // this.$store.dispatch("supplierStore/loadSuppliers");

        if (!this.isCreating){
            this.loadData();
        }
    }
}
</script>

<style lang="scss" scoped>
    #app {
        .highlighted-data {
            font-weight: bold;
            margin-top: auto;
            margin-bottom: auto;
        }
    }
</style>